import { render, staticRenderFns } from "./ApplicantTable.vue?vue&type=template&id=5a5a9b56&"
import script from "./ApplicantTable.vue?vue&type=script&lang=js&"
export * from "./ApplicantTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports